/**
 * Formats money for display across the site (es-ES: 1.234 or 1.234,56).
 */
export function formatPrice(
  price: number | string | null | undefined,
  decimals = 0
): string {
  if (price == null || price === "") {
    return decimals > 0 ? `0,${"0".repeat(decimals)}` : "0";
  }

  const numericPrice = typeof price === "string" ? parseFloat(price) : price;

  if (!Number.isFinite(numericPrice)) {
    return decimals > 0 ? `0,${"0".repeat(decimals)}` : "0";
  }

  return numericPrice.toLocaleString("es-ES", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true,
  });
}

/** Same as formatPrice but always shows 2 decimal places (e.g. 1.234,50). */
export function formatPriceDecimals(
  price: number | string | null | undefined
): string {
  return formatPrice(price, 2);
}

export default formatPrice;
